import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ReactLenis from '@studio-freight/react-lenis';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import './index.css';

function App() {
  return (
    <Router>
      <ReactLenis root options={{ lerp: 0.1, duration: 1.5, smoothTouch: true }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
        </Routes>
      </ReactLenis>
    </Router>
  );
}

export default App;